var map = {
	"./Able.png": "839e",
	"./EMSD.png": "7912",
	"./HA.png": "b823",
	"./HKL.png": "814a",
	"./Melco.png": "5cf0",
	"./NanFung.png": "3122",
	"./NewWorldDevelopment.png": "1670",
	"./OGCIO.png": "1e4d",
	"./SHKP.png": "e427",
	"./ShunTak.png": "bede",
	"./WHARF.png": "e69f",
	"./vtc.png": "a2d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb83";